// Full-screen "not found / unavailable" state for the QR menu. Self-contained
// (inline styles + scoped keyframes) so it needs no dmenu.css changes. Light/white
// palette to match the panel, with softly floating glyphs and a glowing plate.

const GLYPHS = ["🍫", "🍰", "☕", "🧁", "🍮"];

export default function MenuNotFound({
  title = "Menü Bulunamadı",
  message = "",
}) {
  return (
    <div className="mnf-root">
      <style>{`
                .mnf-root {
                    position: fixed;
                    inset: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 24px;
                    overflow: hidden;
                    background:
                        radial-gradient(130% 90% at 50% -10%, #ffffff 0%, #faf6f1 45%, #f1e9df 100%);
                    color: #3a2c1e;
                    font-family: var(--primary-font-set, system-ui, sans-serif);
                    text-align: center;
                }
                .mnf-glyphs { position: absolute; inset: 0; pointer-events: none; }
                .mnf-glyph {
                    position: absolute;
                    font-size: 40px;
                    opacity: 0.65;
                    filter: drop-shadow(0 8px 18px rgba(120, 80, 40, 0.32));
                    animation: mnf-float 9s ease-in-out infinite;
                }
                .mnf-glyph:nth-child(1) { left: 12%;  top: 22%; animation-delay: 0s;    font-size: 40px; }
                .mnf-glyph:nth-child(2) { left: 80%;  top: 18%; animation-delay: 1.2s;  font-size: 28px; }
                .mnf-glyph:nth-child(3) { left: 18%;  top: 74%; animation-delay: 2.4s;  font-size: 32px; }
                .mnf-glyph:nth-child(4) { left: 72%;  top: 70%; animation-delay: 3.1s;  font-size: 44px; }
                .mnf-glyph:nth-child(5) { left: 50%;  top: 12%; animation-delay: 1.8s;  font-size: 26px; }

                .mnf-card {
                    position: relative;
                    max-width: 420px;
                    width: 100%;
                    padding: 44px 30px 34px;
                    border-radius: 26px;
                    background: #ffffff;
                    border: 1px solid rgba(139, 94, 52, 0.14);
                    box-shadow: 0 24px 60px rgba(90, 60, 30, 0.14), 0 2px 8px rgba(90, 60, 30, 0.06);
                    animation: mnf-rise 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
                }
                .mnf-plate {
                    width: 118px;
                    height: 118px;
                    margin: 0 auto 26px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 52px;
                    background: radial-gradient(circle at 50% 35%, #fbf4ea 0%, #f3e6d5 72%);
                    border: 1px solid rgba(139, 94, 52, 0.25);
                    box-shadow: 0 0 0 8px rgba(139, 94, 52, 0.05), 0 14px 30px rgba(90, 60, 30, 0.12);
                    animation: mnf-glow 3.2s ease-in-out infinite;
                }
                .mnf-title {
                    margin: 0 0 10px;
                    font-size: 25px;
                    font-weight: 700;
                    letter-spacing: 0.2px;
                    color: #3a2c1e;
                }
                .mnf-msg {
                    margin: 0;
                    font-size: 14.5px;
                    line-height: 1.6;
                    color: rgba(58, 44, 30, 0.6);
                }
                .mnf-divider {
                    width: 54px;
                    height: 3px;
                    margin: 22px auto 18px;
                    border-radius: 3px;
                    background: linear-gradient(90deg, transparent, #b07a42, transparent);
                    opacity: 0.55;
                }
                .mnf-brand {
                    font-size: 11px;
                    letter-spacing: 1.4px;
                    text-transform: uppercase;
                    color: rgba(139, 94, 52, 0.7);
                    text-decoration: none;
                }
                @keyframes mnf-float {
                    0%, 100% { transform: translateY(0) rotate(-4deg); }
                    50%      { transform: translateY(-22px) rotate(4deg); }
                }
                @keyframes mnf-rise {
                    from { opacity: 0; transform: translateY(22px) scale(0.97); }
                    to   { opacity: 1; transform: translateY(0) scale(1); }
                }
                @keyframes mnf-glow {
                    0%, 100% { box-shadow: 0 0 0 8px rgba(139, 94, 52, 0.05), 0 14px 30px rgba(90, 60, 30, 0.12); }
                    50%      { box-shadow: 0 0 0 14px rgba(139, 94, 52, 0.09), 0 18px 40px rgba(90, 60, 30, 0.16); }
                }
            `}</style>

      <div className="mnf-glyphs" aria-hidden="true">
        {GLYPHS.map((glyph, index) => (
          <span key={index} className="mnf-glyph">
            {glyph}
          </span>
        ))}
      </div>

      <div className="mnf-card">
        <div className="mnf-plate">🍫</div>
        <h1 className="mnf-title">{title}</h1>
        {message ? <p className="mnf-msg">{message}</p> : null}
        <div className="mnf-divider" />
        <a
          className="mnf-brand"
          href="https://noxussoft.com"
          target="_blank"
          rel="noreferrer"
        >
          noxussoft
        </a>
      </div>
    </div>
  );
}
